/* USER FUNCTION ENUMERATIONS */
// DataEntryUserAuthorizationFunction defined in backend DB
/* Use the following SQL and copy the EnumValues column...
SELECT distinct f.DataEntryFunctionDBID, f.DeveloperDescription + ' = ' + cast(f.DataEntryFunctionDBID as nvarchar(4)) + ',' as EnumValues
FROM dbo.LOVDataEntryUserGroup g
	JOIN dbo.LOVDataEntryModule m on g.DataEntryModuleDBID = m.DataEntryModuleDBID
	JOIN dbo.LinkLOVDataEntryUserGroupFunction uf on g.DataEntryUserGroupDBID = uf.DataEntryUserGroupDBID
	JOIN dbo.LOVDataEntryFunction f on uf.DataEntryFunctionDBID = f.DataEntryFunctionDBID
WHERE m.DataEntryModuleCode = 'EM'
ORDER BY f.DataEntryFunctionDBID
*/
export enum AuthFunction {
  Undefined = 0,
  CanSetupConvention = 227,
  CanSetupSubLocalExceptions = 228,
  CanSetupOrganizationList = 229,
  CanSetupOtherAttendeesLOV = 230,
  CanSetupMailingLetterInfoLOV = 231,
  CanSetupMailingReasonsLOV = 232,
  CanSetupLanguagesLOV = 233,
  CanSetupGendersLOV = 234,
  CanSetupAgeGroupsLOV = 235,
  CanSetupMinorityGroupsLOV = 236,
  CanSetupSectoralMeetingsLOV = 237,
  CanGenerateOrgCredentials = 242,
  CanGenerateOfficerCredentials = 243,
  CanSetupDigitalSignature = 244,
  CanGenerateMemberCredentials = 245,
  CanSetupLocalOrg = 246,
  CanSetupOtherAttendees = 247,
  CanUpdateOtherAttendeesFlag = 248,
  CanCreateNewLocalOrg = 249,
  CanGenerateReports = 250,
  CanSetupHeuList = 251,
  CanAddCredentials = 252,
  CanSetupRoleCallDocs = 253,
  CanViewWorkshops = 255,
  CanEditWorkshops = 256,
  CanViewSessions = 257,
  CanEditSessions = 258,
  CanViewRooms = 259,
  CanEditRooms = 260,
  CanEditEvent = 261,
  CanViewEvent = 262
}

/* Use the following SQL and copy the EnumValues column...
SELECT distinct g.DataEntryUserGroupDBID, REPLACE(g.DeveloperDescription, ' ', '') + ' = ' + cast(g.DataEntryUserGroupDBID as nvarchar(4)) + ',' as EnumValues
FROM dbo.LOVDataEntryUserGroup g
	JOIN dbo.LOVDataEntryModule m on g.DataEntryModuleDBID = m.DataEntryModuleDBID
WHERE m.DataEntryModuleCode = 'EM'
ORDER BY g.DataEntryUserGroupDBID
*/
export enum AuthRole {
  ConventionAdministrator = 33,
  ConventionUser = 34,
  ConventionProvincial = 37,
  ConferenceNationalUser = 38,
  ConferenceNationalSupportUser = 39
}

/* Use the following SQL and copy the EnumValues column...
SELECT distinct PhoneTypeDBID, REPLACE(DeveloperDescription, ' ', '') + ' = ' + cast(PhoneTypeDBID as nvarchar(4)) + ',' as EnumValues
FROM dbo.LOVMemberPhoneType
ORDER BY PhoneTypeDBID
*/
export enum MemberPhoneTypes {
  Work = 1,
  Home = 2,
  Fax = 3,
  Cell = 4,
  Unknown = 5,
  LocalUnion = 6,
}

/* Use the following SQL and copy the EnumValues column...
SELECT distinct ElectronicAddressTypeDBID, REPLACE(DeveloperDescription, ' ', '') + ' = ' + cast(ElectronicAddressTypeDBID as nvarchar(4)) + ',' as EnumValues
FROM dbo.LOVMemberElectronicAddressType
ORDER BY ElectronicAddressTypeDBID
*/
export enum MemberEmailTypes {
  Personal = 1,
  Work = 2,
  LocalUnion = 3,
  Unspecified = 4,
}

/* Use the following SQL and copy the EnumValues column...
SELECT distinct PhoneTypeDBID, REPLACE(DeveloperDescription, ' ', '') + ' = ' + cast(PhoneTypeDBID as nvarchar(4)) + ',' as EnumValues
FROM dbo.LOVMemberPhoneType
ORDER BY PhoneTypeDBID
*/
export enum MemberAddressTypes {
  Home = 1,
  Work = 2,
  Unknown = 3,
  LocalOffice = 4
}

export enum LUISEntityContextTypes {
  LocalUnion = 0,
  BargainingUnit = 1,
  Organization = 2,
  CUPEStaff = 3,
  Member = 4,
  ServiceContractGroup = 5
}

export enum LUISGenders {
  Unknown = 0,
  Male = 1,
  Female = 2,
  Transgender = 3
}

export enum LUISLanguages {
  English = 0,
  BilingualEnglish = 1,
  BilingualFrench = 2,
  French = 3
}
